var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')
var _ = require('lodash')

var MailReports = function () {
  // init
  var MailReport = BaseModel.extend({
    urlRoot: Config.api.host + '/mail-reports',
    idAttribute: '_id',
    defaults: {
      enabled: true
    },
    validation: {
      name: {
        required: true
      }
    },
    test: function (data, callback) {
      console.log(this.url() + '/test')
      Backbone.ajax({
        type: 'POST',
        url: this.url() + '/test',
        data: JSON.stringify(data),
        success: function (val) {
          console.log(val)
          
          //App.dialog.alert('Error was resetted successfully.')
          //if (callback) callback(null)
        },
        error: function (val) {
          console.log(val)
          //App.dialog.alert('Error could not be resetted.')
          //if (callback) callback(err)
        }
      })
    },
  })

  var MailReportsCollection = BaseCollection.extend({
    url: Config.api.host + '/mail-reports',
    idAttribute: '_id',
    model: MailReport
  })

  // //
  var API = {
    getMailReportEntities: function (options) {
      var fetchParams = { reset: true }
      if (options) { if (options.query) fetchParams.data = options.query }

      var mailReports = new MailReportsCollection([], options)

      mailReports.fetch(fetchParams)
      return mailReports
    },
    getMailReportEntity: function (id) {
      var mailReport = new MailReport({_id: id})
      mailReport.fetch()
      return mailReport
    },
    newMailReportEntity: function () {
      return new MailReport()
    }
  }

  // Listeners
  App.globalChannel.reply({
    'mailreports:entities': API.getMailReportEntities,
    'mailreports:entity': API.getMailReportEntity
  })

  App.globalChannel.reply('mailreports:entity:new', function () {
    return API.newMailReportEntity()
  })

  // Init
  return API
//
}

module.exports = MailReports



// WEBPACK FOOTER //
// ./js/entities/mailreports.js